import { api } from "../Assets/api/api";

const normalizeSlug = (slug) => (slug || "").replace("?slug=", "");

const bytesToGB = (bytes) => {
  if (!bytes || isNaN(bytes)) return 0;
  return bytes / 1024 ** 3;
};

const extFromName = (fileName = "") =>
  (fileName.split(".").pop() || "").toLowerCase();

const normalizeType = (candidate = "", fileName = "", mimeType = "") => {
  const allowed = new Set(["audio", "video", "image", "document"]);
  const lower = (candidate || "").toLowerCase();
  if (allowed.has(lower)) return lower;

  const ext = extFromName(fileName);
  const mime = (mimeType || "").toLowerCase();

  if (
    mime.startsWith("image/") ||
    ["png", "jpg", "jpeg", "gif", "svg", "webp", "bmp", "tiff"].includes(ext)
  ) {
    return "image";
  }
  if (
    mime.startsWith("video/") ||
    ["mp4", "mov", "avi", "mkv", "webm"].includes(ext)
  ) {
    return "video";
  }
  if (
    mime.startsWith("audio/") ||
    ["mp3", "wav", "aac", "flac", "m4a"].includes(ext)
  ) {
    return "audio";
  }
  // Everything else treated as document
  return "document";
};

const buildPayload = ({
  slug,
  email,
  role = "SuperAdmin",
  extension = "whiteboard",
  feature = "file-explorer",
  fileName,
  storageGB,
  type,
}) => ({
  slug: normalizeSlug(slug),
  email,
  mail: email, // some backends expect `mail`
  storage: storageGB,
  role,
  extension,
  feature,
  fileName,
  type,
});

export const deductStorageForFile = async ({ file, user, slug }) => {
  const email = user?.mail || user?.username || user?.userPrincipalName;
  const storageGB = bytesToGB(file.size);
  const type = normalizeType(file.type, file.name, file.type);
  const payload = buildPayload({
    slug,
    email,
    fileName: file.name,
    storageGB,
    type,
  });
  try {
    await api.post("/api/storage/deduct", payload);
  } catch (e) {
    // non-blocking
  }
};

export const addStorageForItem = async ({ item, user, slug }) => {
  const email = user?.mail || user?.username || user?.userPrincipalName;
  const storageGB = bytesToGB(item?.size || 0);
  const type = normalizeType(item?.type, item?.name, item?.mimeType || "");
  const fileName = item?.name || "unknown";
  const payload = buildPayload({ slug, email, fileName, storageGB, type });
  try {
    await api.post("/api/storage/add", payload);
  } catch (e) {
    // non-blocking
  }
};
